import * as React from 'react';
import PropTypes from 'prop-types';
import ol_Map from 'ol/Map';
import ol_control_ZoomToExtent from 'ol/control/ZoomToExtent';
import { Util } from '../util';
import Map from '../map';

export class ZoomToExtent extends React.Component {
    constructor(props) {
        super(props);
        this.options = {
            className: undefined,
            target: undefined,
            label: undefined,
            tipLabel: undefined,
            extent: undefined
        };
        this.events = {
            'change': undefined,
            'propertychange': undefined
        };
    }
    render() { return null; }
    componentDidMount() {
        let options = Util.getOptions(Object['assign'](this.options, this.props));
        this.control = new ol_control_ZoomToExtent(options);
        this.context.mapComp.controls.push(this.control);
        let olEvents = Util.getEvents(this.events, this.props);
        for (let eventName in olEvents) {
            this.control.on(eventName, olEvents[eventName]);
        }
    }
}
ZoomToExtent['contextTypes'] = {
    mapComp: PropTypes.instanceOf(Map),
    map: PropTypes.instanceOf(ol_Map)
};